// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"060c2b397df450bf","218":"817b6028e80a85d6"}[chunkId] + ".js";
};